import { createApi } from '@reduxjs/toolkit/query/react';
import { config } from '../../config/config';
import {
  IUserAchievementsResponse,
  IUserSportBackgroundResponse,
} from '../../interfaces/user-sport-background.interface';
import { baseQueryWithInterceptor } from '../utils/baseQueryWithInterceptor';

const sportBackgroundApi = createApi({
  reducerPath: 'sportBackgroundApi',
  baseQuery: baseQueryWithInterceptor(
    `${config.API_BASE_URL}/user-sport-background`
  ),
  tagTypes: ['sportBackground'],

  endpoints: (builder) => ({
    getUserSportBackgroundById: builder.query<
      IUserSportBackgroundResponse,
      string
    >({
      query: (id) => `/${id}`,
      providesTags: ['sportBackground'],
    }),
    getMyUserSportBackgrounds: builder.query<
      IUserSportBackgroundResponse[],
      void
    >({
      query: () => '/my',
      providesTags: ['sportBackground'],
    }),
    getUserAchievementsByUserId: builder.query<
      IUserAchievementsResponse[],
      string
    >({
      query: (userId) => `/achievements/userId/${userId}`,
      providesTags: ['sportBackground'],
    }),
    getUserSportBackgroundsBySportId: builder.query<
      IUserSportBackgroundResponse[],
      string
    >({
      query: (sportId) => `/sportId/${sportId}`,
      providesTags: ['sportBackground'],
    }),
    createUserSportBackground: builder.mutation<
      IUserSportBackgroundResponse,
      FormData
    >({
      query: (formData) => ({
        url: '',
        method: 'POST',
        body: formData,
      }),
      invalidatesTags: ['sportBackground'],
    }),
    updateUserSportBackground: builder.mutation<
      IUserSportBackgroundResponse,
      { id: string; formData: FormData }
    >({
      query: ({ id, formData }) => ({
        url: `/${id}`,
        method: 'PUT',
        body: formData,
      }),
      invalidatesTags: ['sportBackground'],
    }),
    upsertUserSportBackground: builder.mutation<
      IUserSportBackgroundResponse,
      FormData
    >({
      query: (formData) => ({
        url: '/upsert',
        method: 'POST',
        body: formData,
      }),
      invalidatesTags: ['sportBackground'],
    }),
    deleteUserSportBackground: builder.mutation<
      IUserSportBackgroundResponse,
      string
    >({
      query: (id) => ({
        url: `/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['sportBackground'],
    }),
  }),
});

export const {
  useGetUserSportBackgroundByIdQuery,
  useGetMyUserSportBackgroundsQuery,
  useGetUserAchievementsByUserIdQuery,
  useGetUserSportBackgroundsBySportIdQuery,
  useCreateUserSportBackgroundMutation,
  useUpdateUserSportBackgroundMutation,
  useUpsertUserSportBackgroundMutation,
  useDeleteUserSportBackgroundMutation,
} = sportBackgroundApi;

export default sportBackgroundApi;
